export var RMAStatus;
(function (RMAStatus) {
    RMAStatus[RMAStatus["ENTERED"] = 1] = "ENTERED";
    RMAStatus[RMAStatus["ISSUED"] = 2] = "ISSUED";
    RMAStatus[RMAStatus["IN_PROGRESS"] = 3] = "IN_PROGRESS";
    RMAStatus[RMAStatus["FULFILLED"] = 4] = "FULFILLED";
    RMAStatus[RMAStatus["CLOSED"] = 5] = "CLOSED";
    RMAStatus[RMAStatus["VOID"] = 6] = "VOID";
})(RMAStatus || (RMAStatus = {}));
//# sourceMappingURL=rma-status.js.map